// import { environment } from './../../environments/environment';
// import { Component, OnInit , AfterViewInit } from '@angular/core';
// import { DataService } from '../data.service';
// import { Router } from '@angular/router';

// declare var $:any;
// declare var System:any;

// @Component({
//   selector: 'app-navbar',
//   templateUrl: './navbar.component.html',
//   styleUrls: ['./navbar.component.css','./bootstrap.min-happcoach.css','../../assets/full-screen-pop-out-navigation/css/reset.css','../../assets/full-screen-pop-out-navigation/css/style.css','../../assets/font-awesome/css/font-awesome.min.css']
// })


// export class NavbarComponent implements OnInit,AfterViewInit {

//   cdClass:boolean=false;

//   constructor(private service: DataService,
//     private router: Router,) {}

//   ngOnInit() {}

//   stratgistLogin(pvarChoice){
//     if(pvarChoice==0){
//       sessionStorage.setItem("IsStratGistLogin","false");
//     } else {
//       sessionStorage.setItem("IsStratGistLogin","true");
//     }
//     this.router.navigate(['/login']);
//     this.service.storageSub.next('change');
//     environment.footer40=false;
//   }

//   ngAfterViewInit(){
//     $(window).scroll(()=>{
//       var scroll=$(window).scrollTop();
//       if(!$('.cd-header').hasClass('is-fixed')){
//         if(scroll>30){
//           $('.cd-header').addClass('is-fixed')
//         }
//         if(scroll==0){
//           $('.cd-header').removeClass('is-fixed')
//         }
//       }
//     })
//   }

// }



import { Component, OnInit , AfterViewInit,EventEmitter} from '@angular/core';
import {DataService} from '../data.service';
import {Router} from '@angular/router';
import {LoginComponent} from '../login/login.component';
import {FooterComponent} from '../footer/footer.component';
import {UserSearch} from '../models/user-search';
import {Guest} from '../module-page/module-page.component';

import {
  AuthService,
  FacebookLoginProvider,
  GoogleLoginProvider,
  LinkedinLoginProvider
} from 'ng4-social-login';

import { SocialUser } from 'ng4-social-login';



declare var $:any;
declare var System:any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css','./bootstrap.min-happcoach.css','../../assets/full-screen-pop-out-navigation/css/reset.css','../../assets/full-screen-pop-out-navigation/css/style.css','../../assets/font-awesome/css/font-awesome.min.css']
})




export class NavbarComponent implements OnInit,AfterViewInit {

public user: SocialUser;
showMenu:boolean=false;
sidebarVisible:boolean=false;
userTypeId:number=-1;
companyId:number=-1;
themeData:any[]=[];
themeChapterData:any[]=[];
public data:any[]=[];
imgPath:string="";
text:string="";
navbarVisible:boolean=true;
cdClass:boolean=false;
userId:number=-1;
selectedThemeIndex:number=0;
sliceFrom:number=0;
sliceTo:number=9;
breakSliceDown:boolean=false;
breakSliceUp:boolean=false;
dropdownProfile:boolean=false;
userName:string="";
guest:Guest=null;

  constructor(
    private service:DataService,
    private router:Router,
    private login:LoginComponent,
    private authService:AuthService,
    private footer:FooterComponent,


  ) {

    System.import('assets/full-screen-pop-out-navigation/js/main.js').then(()=>{
     // console.log("imported");
    })
   }

  ngOnInit() {
   // alert(JSON.stringify(this.userTypeId))
    if(sessionStorage.getItem('Guest')!=null){
      this.guest=JSON.parse(sessionStorage.getItem('Guest'));
    } else {
      this.guest=null;
    }
    let inputJson={};
    inputJson={
     "Email":localStorage.getItem("UserEmail"),
     "UniqueId":this.user==null ? "" : this.user.id,
     "TestUserId":this.guest!=null ? this.guest.guestUserId : -1,
   }
   // console.log(inputJson);
    this.service.LoginUser2(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            this.userName=result['Name'];
            this.userTypeId=result['UserTypeId'];
            localStorage.setItem("UserName",this.userName);
            localStorage.setItem("UserTypeId",JSON.stringify(this.userTypeId));
            localStorage.setItem("UserId",result['Id']);
            localStorage.setItem("planId",result['PlanId']);
            sessionStorage.setItem('ModuleCompleted',result['ModuleCompleted']);
            sessionStorage.setItem('UserRole',result['UserRole']==null ? '' : result['UserRole']);
            sessionStorage.setItem('Department',result['Department']==null ? '' : result['Department']);
            sessionStorage.setItem('Company',result['CompanyName']==null ? '' : result['CompanyName']);
            this.service.storageSub.next('change')
          }
          // else {
          //   this.service.alertMessage(result['Message'],'error');
          // }
        },
        (error)=>{
          console.log(error);
        }
      )
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.companyId=sessionStorage.getItem("companyId")==null ? -1 : parseInt(sessionStorage.getItem("companyId"));
    this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
    // console.log(this.userTypeId);
    // console.log(this.userId);
    this.getAllThemes();

      this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
      this.service.watchStorage().subscribe(()=>{
        this.showMenu=false;
        this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
        this.companyId=sessionStorage.getItem("companyId")==null ? -1 : parseInt(sessionStorage.getItem("companyId"));
          this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
        this.getAllThemes();
      })

  }




  ngAfterViewInit(){
    $('input[placeholder="Browse"]').keypress((e)=>{
      if (e.keyCode == 13) {
        let value=$('input[placeholder="Browse"]').val();
        this.searchForResults(value);
        $('input[placeholder="Browse"]').val('');
  }
});

    $('input[placeholder="Search"]').keypress((e)=>{
      if (e.keyCode == 13) {
        let value=$('input[placeholder="Search"]').val();
        this.searchForResults(value);
        $('input[placeholder="Browse"]').val('');
  }


});

// $('input[placeholder="Browse"]').click((e)=>{
//   setTimeout(()=>{
//     this.showChaptersByTheme(this.themeData[0]['ThemeId'],0)
//
//   },200)
//
// });
$(window).scroll(()=>{
    var scroll=$(window).scrollTop();
  if(!$('.cd-header').hasClass('is-fixed')){
    if(scroll>30){
      $('.cd-header').addClass('is-fixed')
    }
      if(scroll==0){

          $('.cd-header').removeClass('is-fixed')
      }

  }




})
}
  searchForResults(value){

    if(value==""|| value==null){
      this.service.alertMessage("Please enter your search text",'error');
      return false;
    } else {
      this.text=value;
      // this.getSearchModule();
      let searched:UserSearch=new UserSearch(this.userId,this.companyId,this.text,this.service,this.router);
      searched.Search=searched;
      searched.getSearchModule();
      this.showMenu=false;
    }
   this.removeNav();
  }

  logout(){

    // this.login.signOut();
    if(this.user!=null||localStorage.getItem("UserId")!=null){
     // console.log("sign out");
        this.authService.signOut();
        this.login.loggedIn=false;
    }

    this.service.alert("Logout Successful","success");
    sessionStorage.clear();
    localStorage.clear();
    this.removeNav();

    this.router.navigate(['/']);
    this.dropdownProfile=false;

    this.service.storageSub.next('change')

  }

   getAllThemes(){
     this.showMenu=false;
     this.service.GetAllThemes({'CompanyId':this.companyId})
     .subscribe(
       (result:any[])=>{
         if(result['Status']=="Success"){
            this.themeData=result['ThemeData'];
            this.themeChapterData=this.themeData;

           // console.log(this.themeData);
         } else {
            this.service.alert(result['Message'],"error");
         }
       },
       (error)=>{
        // console.log(error);
       }
     )
   }

   showChaptersByTheme(pvarId,i){
       this.themeChapterData=this.themeData.filter(theme=>theme.ThemeId==pvarId);
      this.selectedThemeIndex=i;
    // console.log(i);
    // console.log(pvarId);

   }

   // getSearchModule(){
   //
   //   const inputJson=  {
   //      "CompanyId":this.companyId,
   //       "Text":this.text,
   //       "UserId":this.userId
   //     }
   //    // console.log(inputJson);
   //    console.log(JSON.stringify(inputJson,undefined,2));
   //     this.service.GetSearchModule(inputJson)
   //     .subscribe(
   //       (result:any[])=>{
   //
   //         if(result['Status']=="Success"){
   //           this.data=result['DashBoardData'];
   //           sessionStorage.setItem("SearchItem",JSON.stringify(this.data));
   //           this.service.storageSub.next('changed');
   //           var searchItem:string=this.text.split(' ').join('-')
   //             this.router.navigate(['/search-results',searchItem]);
   //         } else {
   //           this.service.alert(result['Message'],"error")
   //         }
   //
   //       },
   //       (error)=>{
   //        // console.log(error);
   //       },
   //       ()=>{
   //         this.text="";
   //       }
   //     )
   // }

   stratgistLogin(pvarChoice){
     if(pvarChoice==0){
       sessionStorage.setItem("IsStratGistLogin","false");
     } else {
       sessionStorage.setItem("IsStratGistLogin","true");
     }
     this.removeNav();
     this.router.navigate(['/login']);
     this.service.storageSub.next('change');

   }

   removeNav(){
     $('.cd-menu-icon').removeClass('is-clicked');
     $('.cd-primary-nav').removeClass('is-visible');
   }

   hideNavbarRight(){
     this.navbarVisible=!this.navbarVisible;
     this.cdClass=false;
       this.dropdownProfile=false;

   }

   goToModule(pvarName,pvarId){
     pvarName=pvarName.split(' ').join('-');
     const link = '/module/'+ pvarName +'/'+pvarId;
     this.router.navigate(['/'], {skipLocationChange: true})
     .then(() => { this.router.navigate([link]); });

      this.showMenu=false;
   }

   sliceModulesDown(){

     if(this.sliceTo<this.themeData.length){
        this.sliceFrom=this.sliceFrom+1;
       this.sliceTo=this.sliceTo+1;
         // console.log(this.sliceTo);
          if(this.sliceTo>=this.themeData.length){
            this.breakSliceDown=true;
              this.breakSliceUp=false;
             // console.log("if "+this.breakSliceUp);
          }
     } else {
       this.breakSliceDown=true;
       this.breakSliceUp=false;
      // console.log("else "+this.breakSliceUp);
     }

   }

   sliceModulesUp(){
    // console.log("length is "+this.themeData.length);

     if(this.sliceFrom>=0){
        this.sliceFrom=this.sliceFrom-1;
       this.sliceTo=this.sliceTo-1;
         // console.log(this.sliceTo);
         // console.log(this.sliceFrom);
          if(this.sliceFrom==0){
            this.breakSliceUp=true;
              this.breakSliceDown=false;
          }
     } else {
       this.breakSliceUp=true;
     }

   }

   openMenu(){
     this.showMenu=false;
     setTimeout(()=>{
       this.showMenu=true;
       this.sliceFrom=0;
       this.sliceTo=9;
       this.breakSliceDown=false;
       this.breakSliceUp=false;
       this.showChaptersByTheme(this.themeData[0]['ThemeId'],0)
     },200)

   }

   closeMenu(){
     this.removeNav();
     this.hideNavbarRight();
   }

   showDropdownProfile(){
     this.dropdownProfile=true;
   }

   keepNavbarVisibleAndTransparent(){
     this.navbarVisible=true;
     $('.cd-header').removeClass('menu-is-open togglenavbarcolor');
     this.removeNav();
   }


}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/navbar/navbar.component.ts